<template>
    <kgr-generic-modal
        :value="value"
        :headline="headline"
        :scrollable="scrollable"
        @post-input="onInput"
    >
        <div class="content">
            <slot></slot>
        </div>
        <template
            v-if="$slots.footer"
            #footer
        >
            <slot name="footer"></slot>
        </template>
    </kgr-generic-modal>
</template>

<script>
import GenericModal from './GenericModal.vue';

export default {
    components: {
        'kgr-generic-modal': GenericModal,
    },
    props: {
        value: {
            type: Boolean,
            required: false,
        },
        headline: {
            type: String,
            required: false,
            default: null
        },
        scrollable: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.content {
    padding: 0.5rem;
}
</style>
